import { STATUS_META } from "@/lib/statusMap";

// Guest form skips HOD entirely — use neutral wording for admin1_review.
const FORM_OVERRIDES = {
  guest: {
    admin1_review: { label: "Pending Admin-1", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  },
};

export default function StatusBadge({ status, formType }) {
  const override = formType && FORM_OVERRIDES[formType]?.[status];
  const meta = override || STATUS_META[status] ||
    { label: status, cls: "bg-slate-100 text-slate-700 border-slate-300" };
  return (
    <span className={`badge ${meta.cls}`} data-testid={`status-badge-${status}`}>
      {meta.label}
    </span>
  );
}
